// extracted by mini-css-extract-plugin
export var active = "_2w-2";
export var highlight = "_2w-1";
export var highlightLayer = "_2w-0";
export var issuePopover = "_2w-3";
export var statusIcon = "_2w-4";